import React from 'react';
import '../../styles/landing.css'
import PublicHeader from '../../components/public/publicheader';
import * as Constants from '../../constants';
function AboutUs() {
  
  return (
    <div className='landing'>
      <PublicHeader page="aboutus" />

       <section class="div-heros-section" style={{backgroundImage:`url (${Constants.baseurl}/assets/others/lady-justice.png)`}}>
            <div class="div-heros-overlay">
                <div class="div-containers">
                <h1 class="div-heros-title">About Us</h1>
                <nav class="div-heros-nav">
                    <a href="home.html">Home</a>
                    <span class="separator">»</span>
                    <span>About Us</span>
                </nav>
                </div>
            </div>
        </section>
        <section class="content-section">
  <h3>About Us</h3>
  <div class="div-box">
    <div class="my-div-buttons">
      <button class="div-but">Lagos State Court System</button>
      <div class="detaill">
      <p>The Lagos State Judiciary is the oldest Judiciary in Nigeria. Its existence dates back to the period of the Cession of Lagos to the British Government when it was established and known as the Colony Province Judiciary.</p><br/>
      <p>The First Court to be established was the Magistrates' Court. When the High Court was established later, it was called the Supreme Court and its jurisdiction was limited to Lagos. At self-government, the Federal Territory of Lagos inherited the two systems of Courts - the Magistrates' Courts and the Supreme Court.</p><br/>
      <p>At the creation of the Federal Supreme Court, the Lagos Supreme Court became High Court of the Federal Territory Lagos. Hon. Justice Conrad Idowu Taylor became Chief Justice of the Court on the 22nd day of July 1964. The High Court building in Lagos (at Race Course) was the headquarters of the Court and is the oldest and most recognizable Judicial Building in Nigeria.</p><br/>
      <p>When Lagos State was created as one of the twelve states by virtue of provisions of the States (Creation and Transitional Provisions) Decree No. 4 of 1967, which came into effect on 27th May 1967, the High Court and the Magistrate Court of the Federal Territory were merged with the High Court and Magistrate Court of the former Western Region then at Ikeja. This became the Lagos State Judiciary and Hon. Justice Conrad Idowu Taylor became the first Chief Justice of Lagos State. Today, the title of that office is Chief Judge of Lagos State.</p><br/>
      <p>Hon. Justice Taylor ceased to be the Chief Judge on the 7th day of November 1973.The following are the Chief Judges of Lagos State from 1973 to Date:</p>
      <ul>
        <li>Hon. Justice J.A. Adefarasin           <span>1st day of November 1974 to 24th day of April 1985.</span></li>
        <li>Hon. Justice Candide A. Johnson        <span>25th day of April 1985 to 1st day of July 1989.</span></li>
        <li>Hon. Justice Ligali Ayorinde.          <span>1st  July 1989 to 10th day of April 1995.</span></li>
        <li>The first female Chief Judge Hon. Justice Rosaline Omotosho (Mrs) <span>12th day of April 1995 to 27th day of February 1996.</span></li>
        <li>Hon. Justice Olusola Thomas.           <span>15th day of March 1996 to 26th day of November 1996.</span></li>
        <li>Hon. Justice S.O. Ilori.               <span>27th day of December 1996 to 5th day of January 1999.</span></li>
        <li>Hon. Justice Sikiru Adagun.            <span>3rd day of May 1999 to 22nd day of May 199.</span></li>
        <li>Hon. Justice Christopher Olatunde Segun.        <span>24th day of May 1999 to 25th day of May 2001.</span></li>
        <li>Hon. Justice I.A Sotuminu (Mrs) OON.   <span>28th day of May 2001 to 5th day of March 2004.</span></li>
        <li>Hon. Justice Afolabi Adeyinka.        <span>8th day of March 2004 to 22nd day of July 2004.</span></li>
        <li>Hon. Justice Augustine Adetula Ade-Alabi OFR.    <span>8th day of July 2004 to 7th day of August 2009.</span></li>
        <li>Hon. Justice Inumidun Enitan Akande (Mrs) OFR.     <span>8th September, 2009 to 10 June, 2012.</span></li>
        <li>Hon. Justice Ayotunde Adeyoola Phillips (Mrs)        <span>14th day of June, 2012, to 26th day of July 2014.</span></li>
        <li>Hon. Justice Funmilayo Atilade.        <span>20th day of August 2014, to 24th day of September 2017.</span></li>
        <li>Hon Justice Opeyemi Oke        <span>20th day of October 2017 to 10th day of June 2019</span></li>
      </ul><br/>
      <p>The present Chief Judge of Lagos state Hon. Justice Kazeem Alogba  was sworn in as the 17th Chief Judge of Lagos State on the 20th day of August 2019</p><br/>
      <p>The Chief Judge is the head of Courts and as at January 2019, there are fifty-nine (59) Hon. Judges and One Hundred and Fifty-Three (153) Magistrates in the Lagos State Judiciary.</p><br/>
      <p>The Lagos State Judiciary encompasses, High Courts, Magistrate Courts and Customary Courts each with its own Rules.</p><br/>
      <p>The Chief Registrar of the High Court of Lagos State is the Head of Administration, Chief Accounting Officer, Probate Registrar, Sheriff, Official Receiver and the Tax Master. Other Principal Officers are the Deputy Chief Registrars in the Ikeja and Lagos Divisions, Director of Admin and Human Resources, Director of Finance & Accounts and Director of Library Services.</p>
      </div>
    </div>
    <div class="my-div-buttons">
      <button class="div-but">Lagos State Judiciary Organogram</button>
      <div class="detaill">
        <img src={`${Constants.baseurl}/assets/others/orgs.jpg`} />
      </div>
    </div>
    <div class="my-div-buttons">
      <button class="div-but">Historical Landmarks</button>
      <div class="detaill">
        <p>Under the leadership of the Chief Judge of Lagos State, Honourable Justice Opeyemi Oke, a total number of Twenty-Three Thousand, Nine Hundred (23,900) cases were disposed by the High Court and Magistrate Courts between October 2017 and September 2018.</p><br/>
        <p>Establishment of the Small Claims Courts in all the Magisterial Districts, the first of its kind in Nigeria on the 23rd of April, 2018 by Honourable Justice Opeyemi Oke.</p><br/>
        <p>Establishment of Special Offenses Courts and Sexual Offences Courts on the 1st day of February 2018,  by Honourable Justice Opeyemi Oke.</p><br/>
        <p>Introduction of Judiciary Information System (JIS) Electronic filing innovation by Honourable Justice Inumidun Enitan Akande to the High Court of Lagos State in December 2010. To continue the technology innovation, in 2013 Honourable Justice Adeyoola Ayotunde Phillips issued Practice Direction stating that "All processes/matters filed in Lagos High Court must be filed through the Judiciary Information System (JIS) as from 2nd October, 2013". JIS and e-Filing was commissioned on the 2nd day of October 2013 by Honourable Justice Adeyoola Ayotunde Philips.</p><br/>
        <p>Lagos Multi-door Courthouse (LMDC) an Alternative Disputes Resolution (ADR) Center was the first in Nigeria, established on the 11th day of June, 2002 by Honorable Justice I.A Sotuminu, Chief Judge of Lagos State.</p><br/>
        <p>Establishment of the Fast Track Court in the Commercial Division of The Lagos State High Court, Lagos Division, on 26th day April 2004.</p>
      </div>
    </div>
    <div class="my-div-buttons">
      <button class="div-but">Principal Officers of the High Court of Lagos State</button>
            <div class="div-active-table">
        <table class="div-tables">
          <thead>
            <tr>
              <th>S/no</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Image</th>
            </tr>
          </thead>
          <tbody>
            <tr class="one">
              <td>1</td>
              <td>Mr T.A Elias</td>
              <td>Acting Chief Registrar</td>
              <td><img src={`${Constants.baseurl}/assets/others/Elias.jpg`} /></td>
            </tr>
            <tr class="two">
              <td>2</td>
              <td>Mr R.O Davies</td>
              <td>Deputy Chief Registrar (Special Duties) Ikeja</td>
              <td><img src={`${Constants.baseurl}/assets/others/mr_davis.jpg`} /></td>
            </tr>
            <tr class="one">
              <td>3</td>
              <td>Miss I Laguda</td>
              <td>Court Administrator</td>
              <td><img src={`${Constants.baseurl}/assets/others/Laguda.jpg`} /></td>
            </tr>
            <tr class="two">
              <td>4</td>
              <td>Mr K.A Sanusi</td>
              <td>Director of Admin and Human Resources</td>
              <td><img src={`${Constants.baseurl}/assets/others/someone.jpeg`} /></td>
            </tr>
            <tr class="one">
              <td>5</td>
              <td>Mrs F.M Oladogba</td>
              <td>Acting Chief Registrar</td>
              <td><img src={`${Constants.baseurl}/assets/others/Oladogba.jpeg`} /></td>
            </tr>
          </tbody>
        </table>
            </div>
    </div>
    <div class="my-div-buttons">
      <button class="div-but">Retired Hon. Chief Judges of the High Court of Lagos State</button>
      <div class="div-active-table">
        <table class="div-tables">
          <thead>
            <tr>
            <th>S/No</th>
            <th>Name</th>
            <th>Timeline</th>
            </tr>
          </thead>
          <tbody>
            <tr class="one">
              <td>1</td>
              <td>Hon. Justice John Idowu Conrad Taylor</td>
              <td>July 22, 1964 - Nov 27, 1973</td>
            </tr>
            <tr class="two">
              <td>2</td>
              <td>Hon. Justice Joseph Adetunji Adefarasin (Decd.)</td>
              <td>Nov 01, 1974-Apr 24, 1985</td>
            </tr>
            <tr class="one">
              <td>3</td>
              <td>Hon. Justice Candide Ademola Johnson (Decd.)</td>
              <td>Apr 25, 1985-Jul 01, 1989</td>
            </tr>
            <tr class="two">
              <td>4</td>
              <td>Hon. Justice Ligali Akanni Ayorinde (Decd.)</td>
              <td>Jul 01, 1989-Apr 10, 1995</td>
            </tr>
            <tr class="one">
              <td>5</td>
              <td>Hon. Justice Roseline Ajoke Omotoso (Mrs.) (Decd.)</td>
              <td>Apr 12, 1995-Feb 27, 1996</td>
            </tr>
            <tr class="two">
              <td>6</td>
              <td>Hon. Justice Olusola Olatunde Thomas (Decd.)</td>
              <td>Mar 15, 1996-Nov 01, 1996</td>
            </tr>
            <tr class="one">
              <td>7</td>
              <td>Hon. Justice Samuel Omotunde Ilori</td>
              <td>Dec 27, 1996-Jan 05, 1999</td>
            </tr>
            <tr class="two">
              <td>8</td>
              <td>Hon. Justice Sikiru Olatunde Adagun</td>
              <td>May 03, 1999-May 22, 1999</td>
            </tr>
            <tr class="one">
              <td>9</td>
              <td>Hon. Justice Christopher Olatunde Segun</td>
              <td>May 24, 1999-May 25, 2011</td>
            </tr>
            <tr class="two">
              <td>10</td>
              <td>Hon. Justice Ibitola Adebisi Sotuminu O. O. N.</td>
              <td>May 28, 2001-May 05, 2004</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="my-div-buttons">
      <button class="div-but">Retired/Elevated/Deceased Judges of the High Court of Lagos</button>
    </div>
  </div>
</section>
    </div>
  );
}

export default AboutUs;